import React, { useEffect, useMemo, useState, lazy } from "react";
import objectPath from "object-path";
import CloseIcon from "@material-ui/icons/Close";
import {
  Button,
  makeStyles,
  Dialog,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import clsx from "clsx";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
import { useHistory } from "react-router";
import {
  onAxiosApiCall,
  getLanguage,
  useLocalStorage,
  nl2br,
} from "../../../utils";
import { KTUtil } from "./../../_assets/js/components/util.js";
import { LayoutInit } from "./LayoutInit";
import { ScrollTop } from "./extras/ScrollTop";
import { API_URL } from "../../../constants";
const MyReferral = lazy(() => import("../../../app/pages/MyReferral"));

const useStyles = makeStyles({
  notificationDiv: {
    width: "100%",
    padding: 10,
  },
  notificationContent: {
    width: "100%",
    padding: 10,
    display: "flex",
    flexDirection: "row",
    borderRadius: 10,
    "&.errorContent": {
      backgroundColor: "#bd362fc9",
    },
    "&.successContent": {
      backgroundColor: "#008000c9",
    },
  },
  notificationMessageDiv: {
    padding: 10,
    width: "98%",
    textAlign: "center",
    "& .notification-message": {
      fontWeight: "500",
      fontSize: "1.1rem",
      lineHeight: "20px",
      letterSpacing: "0.05em",
      color: "#FFF",
      margin: 0,
      "& br": {
        display: "block",
        height: "5px",
        content: '" "',
      },
      "& i": {
        fontSize: "inherit",
        color: "inherit",
      },
    },
  },
  notificationAction: {
    padding: "20px 10px 0px",
  },
  notificationCloseIcon: {
    width: "2%",
    marginBottom: 5,
    display: "flex",
    justifyContent: "flex-end",
  },
  dialogMain: {
    borderRadius: "8px",
  },
  dialogPaper: {
    height: "85vh",
    maxWidth: "450px",
    padding: "40px 32px",
    /* @media (max-width:767px) {
      padding: 20px;
    } */
  },
  closeButton: {
    cursor: "pointer",
    margin: "0 !important",
    padding: "0 !important",
    position: "absolute",
    top: "10px",
    right: "10px",
    "& svg": {
      width: "1.5em",
      height: "1.5em",
      "& path": {
        fill: "#1D1D1D",
      },
    },
  },
});

export function Layout({ children }) {
	const history = useHistory();
  const [localStorageData] = useLocalStorage("clientpanel");
  const language = getLanguage(navigator.language, localStorageData);
  const [openAlertMessage, setOpenAlertMessage] = useState(false);
  const [alertMessage, setAlertMessage] = useState({});
  const [openReferralDialog, setOpenReferralDialog] = useState(false);
  const classes = useStyles();
  const isAuthorized = JSON.parse(localStorage.getItem("clientpanel"))
    ? true
    : false;

  useEffect(() => {
    if (isAuthorized) {
      var apiBody = { page: 1, record_per_page: 1 };
      onAxiosApiCall(API_URL + "get-notification", "POST", apiBody)
        .then((response) => {
          if (response.status === 200) {
            if (
              response.data !== undefined &&
              response.data.rows !== undefined &&
              response.data.rows.length > 0
            ) {
              var notification = response.data.rows[0];

              try {
                notification.notification = JSON.parse(
                  notification.notification
                );
                notification.notification = notification.notification[language];
              } catch (error) {
                console.log("notification text error", error);
              }

              setOpenAlertMessage(true);
              setAlertMessage(notification);
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, []);

  const handleNotificationClose = () => {
    var apiBody = { id: alertMessage.id };
    onAxiosApiCall(API_URL + "read-notification", "POST", apiBody)
      .then((response) => {
        setOpenAlertMessage(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleNotificationUpgrade = () => {
    var apiBody = { id: alertMessage.id };
    onAxiosApiCall(API_URL + "read-notification", "POST", apiBody)
      .then((response) => {
        setOpenAlertMessage(false);
        window.location.href = alertMessage.action_link;
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleNotificationContentClick = (e) => {
    if (
      e.target !== undefined &&
      e.target !== null &&
      e.target.tagName !== undefined &&
      e.target.tagName === "A"
    ) {
      handleNotificationClose();
    }
  };

  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        "header.self.fixed.desktop"
      ),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  return layoutProps.selfLayout !== "blank" ? (
    <>
      {/*begin::Main*/}
      <HeaderMobile />
      <div className="d-flex flex-column flex-root main-container">
        {/*begin::Page*/}
        <div className="d-flex flex-row flex-column-fluid page">
          {layoutProps.asideDisplay && <Aside />}
          {/*begin::Wrapper*/}
          <div
            className="d-flex flex-column flex-row-fluid wrapper"
            id="kt_wrapper"
            style={{ paddingTop: 0 }}
          >
            {/* <Header/> */}
            {/*begin::Content*/}
            {openAlertMessage && (
              <div className={classes.notificationDiv}>
                <div
                  className={clsx(
                    classes.notificationContent,
                    alertMessage.message_type !== undefined &&
                      alertMessage.message_type == "Success"
                      ? "successContent"
                      : "errorContent"
                  )}
                >
                  <div className={classes.notificationMessageDiv}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: nl2br(alertMessage.notification),
                      }}
                      onClick={handleNotificationContentClick}
                      className="notification-message"
                    ></div>

                    {alertMessage.message_type == "Error" &&
                      alertMessage.action_link != null &&
                      alertMessage.action_link != "" && (
                        <div className={classes.notificationAction}>
                          <Button
                            className="btn btn-primary green-button"
                            onClick={handleNotificationUpgrade}
                          >
                            Upgrade
                          </Button>
                        </div>
                      )}

                    {alertMessage.message_type == "Success" && (
                      <div className={classes.notificationAction}>
                        <Button
                          className="btn btn-primary green-button"
                          onClick={handleNotificationClose}
                        >
                          Ok
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className={classes.notificationCloseIcon}>
                    <CloseIcon
                      style={{
                        color: "#fff",
                        cursor: "pointer",
                        width: "1.3em",
                        height: "1.3em",
                      }}
                      onClick={handleNotificationClose}
                    />
                  </div>
                </div>
              </div>
            )}

            <div
              id="kt_content"
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
              style={{ padding: "20px 25px 25px 25px" }}
            >
              {/* {layoutProps.subheaderDisplay && <SubHeader/>} */}
              {/*begin::Entry*/}
              {!layoutProps.contentExtended && (
                <React.Fragment>
									{history.location.pathname !== '/my-referral' && 
										<div className="d-flex flex-row justify-content-end mb-5">
											<button
												className="btn btn-primary"
												onClick={() => setOpenReferralDialog(true)}
                        id="globalReferAndEarnBtn"
											>
												<i className="fas fa-gift"></i><span className="buttom-text">--Refer and Earn</span>
											</button>
										</div>
									}
                  <div className="d-flex flex-column-fluid">
                    {/*begin::Container*/}
                    <div className={layoutProps.contentContainerClasses}>
                      {children}
                    </div>
                    {/*end::Container*/}
                  </div>
                </React.Fragment>
              )}

              {layoutProps.contentExtended && { children }}
              {/*end::Entry*/}
            </div>
            {/*end::Content*/}
            {/* <Footer/> */}
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}

        <Dialog
          fullScreen={KTUtil.isMobileDevice() ? true : false}
          fullWidth={true}
          open={openReferralDialog}
          onClose={(e, type) => {
            if (type !== "backdropClick" && type !== "escapeKeyDown") {
              setOpenReferralDialog(false);
            }
          }}
          aria-labelledby="form-dialog-title"
          classes={{
            container: classes.dialogMain,
            paper: classes.dialogPaper,
          }}
        >
          <DialogContent className="container p-0 d-flex flex-column">
            <IconButton
              aria-label="close"
              onClick={() => setOpenReferralDialog(false)}
              className={classes.closeButton}
            >
              <CloseIcon />
            </IconButton>

            <MyReferral dialog={true}/>
          </DialogContent>
        </Dialog>
      </div>

      <ScrollTop />

      {/*end::Main*/}
      <LayoutInit />
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
